<div class="number-stats">
  <div class="card stat-card">
    <div class="card-content" [ngClass]="alignmentClass">
      <div class="card-title" [innerHTML]="formattedTitle"></div>
      <div class="card-value-or-error">
        <ng-container *ngIf="!hasError">
          <input
            *ngIf="isInputNumberStat; else readonlyStat"
            class="card-value card-value-input"
            type="text"
            [ngModel]="statInputValue"
            (ngModelChange)="onStatInputChange($event)"
            (keyup.enter)="onInputStatEnter()"
          />
          <ng-template #readonlyStat>
            <div class="card-value" [ngClass]="valueLengthClass">{{ stat }}</div>
          </ng-template>
        </ng-container>
        <mat-icon *ngIf="hasError" class="stat-error-icon">error_outline</mat-icon>
      </div>
    </div>
  </div>
</div>
